import Icon from "../assets/icons";
import { Outlet, useLocation } from "react-router-dom";

const GuestLayout = () => {
  const location = useLocation();
  const isSignup = location.pathname === '/signup';
  // const backgroundImage = "/img/background.png";
  const backgroundImage = isSignup
    ? "/auth/auth-bg.png"
    : "/auth/auth-bg.png";
  return (
    <div className="bg-white rounded-t-2xl h-screen grid grid-cols-2">
      <div className="h-full bg-[#F1F3FF] shadow-[6px_0_16px_0_rgba(0,0,0,0.5)] mobile:col-span-2 relative">

        <div className="h-full w-3/4 mx-auto">
          <Outlet />
        </div>

        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-3/4 text-[#5F488A] font-semibold mobile:text-center">
          &copy; Viliyo, 2026
        </div>

      </div>
      <div
        className="bg-cover sepia bg-center bg-no-repeat p-10 mobile:hidden"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      ></div>
    </div>
  );
};

export default GuestLayout;
